<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1100" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" hide-details />
        </div>

        <SectionLayout
          :showContainerStyle="false"
          :showCustomWidth="false"
          :settings="fields.settings"
          :container-page="fields.containerPage"
        />

        <div class="mb-5">
          <label class="label-input">Media</label>
          <div class="group-item">
            <v-radio-group v-model="mediaType" row hide-details class="mt-0 mb-3">
              <v-radio label="Video" value="video" />
              <v-radio label="Image" value="image" />
            </v-radio-group>
            <template v-if="mediaType === 'video'">
              <v-text-field v-model="fields.media.videoSrc" hide-details class="mb-3" />
              <VideoPreview :value="fields.media.videoSrc" />
            </template>
            <UploadImage
              v-else
              :image="{ imageSrc: fields.media.image }"
              :height="`260`"
              :typeUpload="'image'"
              @callback="obj => (fields.media.image = obj.imageSrc)"
              @callbackDelete="fields.media.image = ''"
            />
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Highlights (max {{ MAX_HIGHLIGHT_ITEMS }})</label>
            <v-btn
              small
              color="primary"
              :disabled="fields.highlights.items.length >= MAX_HIGHLIGHT_ITEMS"
              @click="handleAddHighlight"
            >
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Highlight</span>
            </v-btn>
          </div>
          <div class="group-item mb-3">
            <v-row>
              <v-col cols="12" md="6">
                <v-checkbox v-model="fields.highlights.show" label="Show highlights" hide-details class="mt-0" />
              </v-col>
              <v-col cols="12" md="6">
                <label>Columns per view</label>
                <!-- <v-text-field
                  v-model.number="fields.highlights.colPerView"
                  type="number"
                  min="1"
                  hide-details
                  class="mt-0"
                /> -->
                <v-select
                  v-model.number="fields.highlights.colPerView"
                  :items="[
                    { text: '1', value: 1 },
                    { text: '2', value: 2 },
                    { text: '3', value: 3 },
                    { text: '4', value: 4 },
                    { text: '5', value: 5 },
                    { text: '6', value: 6 },
                  ]"
                  hide-details
                  class="mt-0"
                />
              </v-col>
            </v-row>
          </div>
          <div class="group-item">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.highlights.items" :key="`highlight-item-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center" style="width: 100%">
                    <span>Item {{ index + 1 }}</span>
                    <v-btn
                      icon
                      :disabled="fields.highlights.items.length <= MIN_HIGHLIGHT_ITEMS"
                      @click.stop="handleRemoveHighlight(index)"
                    >
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';
import SectionLayout from '../common/ui-modules/section-layout/editor.vue';
import VideoPreview from '../common/ui-modules/inputs/video-preview.vue';

const MAX_HIGHLIGHT_ITEMS = 6;
const MIN_HIGHLIGHT_ITEMS = 1;

const buildHighlightItemDefault = () => ({
  content: '<h3></h3><p></p>',
});

const getDefaultFields = () => ({
  title: 'Calyrafit Banner Section',
  settings: {
    paddingTop: true,
    paddingBottom: true,
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    overlayColor: '#000000',
    overlayOpacity: 0,
    showOverlay: false,
    backgroundImage: '',
    useCustomWidth: false,
    customWidth: 1204,
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  media: {
    useVideo: true,
    videoSrc: '',
    image: '',
  },
  highlights: {
    show: true,
    colPerView: 4,
    items: [
      { content: '<h3>200k+</h3><p>5 Star Reviews</p>' },
      { content: '<h3>200k+</h3><p>5 Star Reviews</p>' },
      { content: '<h3>200k+</h3><p>5 Star Reviews</p>' },
      { content: '<h3>200k+</h3><p>5 Star Reviews</p>' },
    ],
  },
});

export default {
  name: 'CalyrafitBannerSectionEditor',
  components: { UploadImage, SectionLayout, VideoPreview },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      MAX_HIGHLIGHT_ITEMS,
      MIN_HIGHLIGHT_ITEMS,
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: getDefaultFields(),
    };
  },
  computed: {
    mediaType: {
      get() {
        return this.fields.media.useVideo ? 'video' : 'image';
      },
      set(val) {
        this.fields.media.useVideo = val === 'video';
      },
    },
  },
  mounted() {
    const def = getDefaultFields();
    const extract = cloneDeep(this.sectionEditor.sectionExtract || {});

    this.fields = {
      ...def,
      ...extract,
      settings: { ...def.settings, ...(extract.settings || {}) },
      containerPage: { ...def.containerPage, ...(extract.containerPage || {}) },
      media: { ...def.media, ...(extract.media || {}) },
      highlights: {
        ...def.highlights,
        ...(extract.highlights || {}),
        items:
          Array.isArray(extract.highlights?.items) && extract.highlights.items.length
            ? extract.highlights.items.slice(0, MAX_HIGHLIGHT_ITEMS)
            : def.highlights.items,
      },
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        highlights: {
          ...this.fields.highlights,
          items: (this.fields.highlights.items || []).slice(0, MAX_HIGHLIGHT_ITEMS),
        },
      };
      const updateHtml = updateHtmlFromData.sectionCalyrafitBanner(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddHighlight() {
      if (this.fields.highlights.items.length >= MAX_HIGHLIGHT_ITEMS) return;
      this.fields.highlights.items.push(cloneDeep(buildHighlightItemDefault()));
    },
    handleRemoveHighlight(index) {
      if (this.fields.highlights.items.length <= MIN_HIGHLIGHT_ITEMS) return;
      this.fields.highlights.items.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.ck-editor__editable_inline,
.ck-editor__editable {
  min-height: 100px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
